export default __webpack_public_path__ + "static/media/tooltip_checked.52edff85.svg";